import { SortControl as DSSortControl } from 'admination-react'
import type { SortValue } from 'admination-react'

export type SortState = { key: string; dir: 'asc' | 'desc' } | null

export function SortControl({
  sort,
  onChange,
  options,
}: {
  sort: SortState
  onChange: (sort: NonNullable<SortState>) => void
  options: { key: string; label: string }[]
}) {
  const value: SortValue = sort ?? { key: '', dir: 'asc' }
  return <DSSortControl options={options.map(({ key, label }) => ({ key, label, icon: ({ name: 'i-text', bezeichnung: 'i-text', stage: 'i-status', status: 'i-status', email: 'i-send', nummer: 'i-ticket', ue: 'i-clock' } as Record<string, string>)[key] ?? 'i-text' }))} value={value} onChange={onChange} label="Sortieren" />
}
